export const BASE_SP_URL_PRODUCTION = 'api.auth.adobe.com';
export const REGISTERED_DOMAIN = 'local.stream.vice.com';
export const REDIRECT_URL = 'http://local.stream.vice.com:8080/home';
